<div class="message-bubble">
  <div data-automation-id="message-typing-indicator">
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>
